import socialLogin from "./socialLogin"
export default socialLogin;
